import { selectAllVariants } from '@ff-scene-plugins/photo-prints-redux/selectors/variantSelectors';
import { selectHasMagicBorderApplied, actions as generalUiActions } from '@ff-scene-plugins/photo-prints-redux/slices/generalUiSlice';
import { PhotoPrintsPdpDispatch, PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { magic_effects } from '@ff-scene-plugins/photo-prints-shared/magic_effects';
import { applyMagicBorderThunk } from '../thunks/applyMagicBorderThunk';
import { updateVariant } from '../thunks/updateVariant';

/**
 * Automatically applies the first available magic border if the variant ID contains "fotofun"
 * This should be called when:
 * 1. A new group is created with a fotofun variant
 * 2. An existing group's variant is changed to include fotofun
 * 
 * Only applies if:
 * - The variant contains "fotofun"  
 * - The group doesn't already have a magic border applied
 * - The borderId is not already set (to avoid overwriting existing border selection)
 */
export const applyFirstMagicBorderIfFotofun = (
    groupId: string,
    variantId?: string
) => {
    return (dispatch: PhotoPrintsPdpDispatch, getState: () => PhotoPrintsPdpState) => {
        const state = getState();
        
        // If no variantId provided, try to get it from the group
        let targetVariantId = variantId;
        if (!targetVariantId) {
            const group = state.project.groups.entities[groupId];
            targetVariantId = group?.variantId;
        }
        
        if (!targetVariantId) {
            return;
        }
        
        // Find the variant to check if it contains "fotofun"
        const variants = selectAllVariants(state);
        const variant = variants.find(v => v?.id === targetVariantId);
        
        if (!variant || !variant.id.includes('fotofun')) {
            return;
        }
        
        // Don't apply if the group already has a magic border applied
        const hasMagicBorderApplied = selectHasMagicBorderApplied(state, groupId);
        if (hasMagicBorderApplied) {
            return;
        }
        
        // Don't apply if the variant already has a specific borderId (other than fotofun-border or without-border)
        if (variant.borderId && variant.borderId !== 'fotofun-border' && variant.borderId !== 'without-border') {
            return;
        }
        
        // Get the first available magic effect
        const firstMagicEffect = magic_effects[0];
        if (!firstMagicEffect) {
            return;
        }
        
        // Ensure the variant has fotofun-border 
        if (variant.borderId !== 'fotofun-border') {
            dispatch(updateVariant(variant.paperId, variant.sizeId, groupId, 'fotofun-border'));
        }
        
        // Apply the first magic border
        dispatch(applyMagicBorderThunk(groupId, firstMagicEffect.id));

        // Trigger the visual effects animation
        dispatch(generalUiActions.triggerMagicBorderAutoApplied(groupId));
    };
};